/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class UserApi extends runtime.BaseAPI {
    /**
     * Create new user.
     * Create User
     */
    async v1AdminCreateUserRaw(requestParameters, initOverrides) {
        if (requestParameters['userCreate'] == null) {
            throw new runtime.RequiredError('userCreate', 'Required parameter "userCreate" was null or undefined when calling v1AdminCreateUser().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/user/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['userCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create new user.
     * Create User
     */
    async v1AdminCreateUser(requestParameters, initOverrides) {
        const response = await this.v1AdminCreateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete the user associated with the user id.
     * Delete User
     */
    async v1AdminDeleteUserRaw(requestParameters, initOverrides) {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling v1AdminDeleteUser().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/user/{user_id}`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Delete the user associated with the user id.
     * Delete User
     */
    async v1AdminDeleteUser(requestParameters, initOverrides) {
        const response = await this.v1AdminDeleteUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieve users.
     * Read Users
     */
    async v1AdminReadUsersRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/user/`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Retrieve users.
     * Read Users
     */
    async v1AdminReadUsers(requestParameters = {}, initOverrides) {
        const response = await this.v1AdminReadUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Grant or revoke access from one user to another.
     * Set User Access
     */
    async v1AdminSetUserAccessRaw(requestParameters, initOverrides) {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling v1AdminSetUserAccess().');
        }
        if (requestParameters['accessibleUserId'] == null) {
            throw new runtime.RequiredError('accessibleUserId', 'Required parameter "accessibleUserId" was null or undefined when calling v1AdminSetUserAccess().');
        }
        if (requestParameters['hasAccess'] == null) {
            throw new runtime.RequiredError('hasAccess', 'Required parameter "hasAccess" was null or undefined when calling v1AdminSetUserAccess().');
        }
        const queryParameters = {};
        if (requestParameters['hasAccess'] != null) {
            queryParameters['has_access'] = requestParameters['hasAccess'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/user/{user_id}/access/{accessible_user_id}`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"accessible_user_id"}}`, encodeURIComponent(String(requestParameters['accessibleUserId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Grant or revoke access from one user to another.
     * Set User Access
     */
    async v1AdminSetUserAccess(requestParameters, initOverrides) {
        const response = await this.v1AdminSetUserAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Grant or revoke access to one target user for multiple users.
     * Set User Access Bulk
     */
    async v1AdminSetUserAccessBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['adminId'] == null) {
            throw new runtime.RequiredError('adminId', 'Required parameter "adminId" was null or undefined when calling v1AdminSetUserAccessBulk().');
        }
        if (requestParameters['userAccessBulkUpdate'] == null) {
            throw new runtime.RequiredError('userAccessBulkUpdate', 'Required parameter "userAccessBulkUpdate" was null or undefined when calling v1AdminSetUserAccessBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/user/access/{admin_id}`;
        urlPath = urlPath.replace(`{${"admin_id"}}`, encodeURIComponent(String(requestParameters['adminId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['userAccessBulkUpdate'],
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Grant or revoke access to one target user for multiple users.
     * Set User Access Bulk
     */
    async v1AdminSetUserAccessBulk(requestParameters, initOverrides) {
        const response = await this.v1AdminSetUserAccessBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Grant or revoke access to one target user for multiple users, by username.
     * Set User Access Bulk By Username
     */
    async v1AdminSetUserAccessBulkByUsernameRaw(requestParameters, initOverrides) {
        if (requestParameters['adminUsername'] == null) {
            throw new runtime.RequiredError('adminUsername', 'Required parameter "adminUsername" was null or undefined when calling v1AdminSetUserAccessBulkByUsername().');
        }
        if (requestParameters['userAccessBulkUpdateByUsername'] == null) {
            throw new runtime.RequiredError('userAccessBulkUpdateByUsername', 'Required parameter "userAccessBulkUpdateByUsername" was null or undefined when calling v1AdminSetUserAccessBulkByUsername().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/user/access/by-username/{admin_username}`;
        urlPath = urlPath.replace(`{${"admin_username"}}`, encodeURIComponent(String(requestParameters['adminUsername'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['userAccessBulkUpdateByUsername'],
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Grant or revoke access to one target user for multiple users, by username.
     * Set User Access Bulk By Username
     */
    async v1AdminSetUserAccessBulkByUsername(requestParameters, initOverrides) {
        const response = await this.v1AdminSetUserAccessBulkByUsernameRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update the user associated with the user id.
     * Update User
     */
    async v1AdminUpdateUserRaw(requestParameters, initOverrides) {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling v1AdminUpdateUser().');
        }
        if (requestParameters['userUpdate'] == null) {
            throw new runtime.RequiredError('userUpdate', 'Required parameter "userUpdate" was null or undefined when calling v1AdminUpdateUser().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/user/{user_id}`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['userUpdate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Update the user associated with the user id.
     * Update User
     */
    async v1AdminUpdateUser(requestParameters, initOverrides) {
        const response = await this.v1AdminUpdateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get current user.
     * Read User Me
     */
    async v1ReadCurrentUserRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/user/me`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get current user.
     * Read User Me
     */
    async v1ReadCurrentUser(initOverrides) {
        const response = await this.v1ReadCurrentUserRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get a specific user by id.
     * Read User
     */
    async v1ReadUserRaw(requestParameters, initOverrides) {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling v1ReadUser().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/user/{user_id}`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a specific user by id.
     * Read User
     */
    async v1ReadUser(requestParameters, initOverrides) {
        const response = await this.v1ReadUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
